export const CLASS_INFO_REF = 'classInfoRef';
export const CLASS_INFO_CONNECTION_REF = 'infoConnectionRef';
export const CLASS_CHAT_REF = 'chatRef';
export const CLASS_INFO_SETTINGS_REF = 'infoSettingsRef';
export const CLASS_CAPTURES_REF = 'infoCapturesRef';
export const CLASS_INFO_FOOTER_REF = 'infoFooterRef';
export const CLASS_SCREENSHOT_CAROUSEL_REF = 'screenshotCarouselRef';

